/**
 * Customer keys — the Pipeline row key, also the drill-down URL segment (#50).
 *
 * A customer is billed under exactly one identity (DEC-192 option A): the current
 * `haulerOperatorId`, else the legacy `operatorId`. The key prefixes the id with which
 * one it is, so the two can never collide: `ho:<uuid>` or `op:<uuid>`.
 */

/** The customer an invoice is generated for — exactly one identity. */
export type CustomerIdentity =
  | { readonly haulerOperatorId: string }
  | { readonly operatorId: string };

const KEY = /^(ho|op):([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i;

export function customerKey(customer: CustomerIdentity): string {
  return 'haulerOperatorId' in customer
    ? `ho:${customer.haulerOperatorId}`
    : `op:${customer.operatorId}`;
}

/** The identity a key names, or null for anything that isn't a well-formed key. */
export function parseCustomerKey(key: string): CustomerIdentity | null {
  const m = KEY.exec(key);
  if (m === null) return null;
  const id = (m[2] ?? '').toLowerCase();
  return m[1]?.toLowerCase() === 'ho' ? { haulerOperatorId: id } : { operatorId: id };
}
